export interface BrandConfig {
  code: string;
  name: string;
  displayName: string;
  primaryColor: string;
  secondaryColor: string;
  logo: string;
  logoCollapsed: string;
  logoCard: string;
  welcomeMessage: {
    fr: string;
    en: string;
    es: string;
    de: string;
    lb: string;
    nl: string;
  };
}

export const BRANDS: Record<string, BrandConfig> = {
  fidone: {
    code: 'fidone',
    name: 'FidOne',
    displayName: 'FidOne',
    primaryColor: '#556ee6',
    secondaryColor: '#74788d',
    logo: '/logo-fidone.png',
    logoCollapsed: '/icone_One_blanc.png',
    logoCard: '/logo-fidone-blanc.png',
    welcomeMessage: {
      fr: 'Bienvenue sur FidOne',
      en: 'Welcome to FidOne',
      es: 'Bienvenido a FidOne',
      de: 'Willkommen bei FidOne',
      lb: 'Wëllkomm bei FidOne',
      nl: 'Welkom bij FidOne',
    },
  },
  weldom: {
    code: 'weldom',
    name: 'Weldom',
    displayName: 'Weldom',
    primaryColor: '#ff6600',
    secondaryColor: '#333333',
    logo: '/weldom.png',
    logoCollapsed: '/weldom.png',
    logoCard: '/logo-weldom-blanc.png',
    welcomeMessage: {
      fr: 'Bienvenue sur Weldom',
      en: 'Welcome to Weldom',
      es: 'Bienvenido a Weldom',
      de: 'Willkommen bei Weldom',
      lb: 'Wëllkomm bei Weldom',
      nl: 'Welkom bij Weldom',
    },
  },
};

export const DEFAULT_BRAND = 'fidone';

export function getBrandFromHostname(hostname: string): BrandConfig {
  const parts = hostname.split('.');
  
  if (parts.length >= 3) {
    const brandCode = parts[0];
    if (BRANDS[brandCode]) {
      return BRANDS[brandCode];
    }
  }
  
  return BRANDS[DEFAULT_BRAND];
}
